import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { Organisation } from './organisation';

@Injectable({
    providedIn: 'root',
})
export class OrganisationService {
    private http = inject(HttpClient);


    public getOrganisationen(): Observable<Organisation[]> {
        return this.http.get(environment.API_URL + '/organisation') as Observable<Organisation[]>;
    }

    public getOrganisationenWithZuweisungDeaktiviert(zuweisungDeaktiviert: boolean): Observable<Organisation[]> {
        return this.http.get(environment.API_URL + '/organisation?zuweisungDeaktiviert=' + zuweisungDeaktiviert) as Observable<Organisation[]>;
    }

    public getOrganisation(orgId: string): Observable<Organisation> {
        return this.http.get(environment.API_URL + '/organisation/' + orgId) as Observable<Organisation>;
    }

    public existsInEic1OrEic2OrEic3(eicNummer: string): Observable<boolean> {
        let params = new HttpParams();
        params = params.set('eicNummer', eicNummer);
        return this.http.get<boolean>(environment.API_URL + '/organisation/existsInEic1OrEic2OrEic3', { params });
    }

    public existsOrgWithName(name: string): Observable<boolean> {
        let params = new HttpParams();
        params = params.set('name', name);
        return this.http.get<boolean>(environment.API_URL + '/organisation/existsOrgWithName', { params });
    }

    public existsByStromNetzbetreiberNummer(stromNetzbetreiberNummer: string): Observable<boolean> {
        let params = new HttpParams();
        params = params.set('stromNetzbetreiberNummer', stromNetzbetreiberNummer);
        return this.http.get<boolean>(environment.API_URL + '/organisation/existsByStromNetzbetreiberNummer', { params });
    }

    // HTTP-spec-error: why is put = edit, and post = create?
    public async updateOrganisation(orgId: string, orgJson: string): Promise<HttpResponse<any>> {
        return this.http.put(environment.API_URL + '/organisation/' + orgId, orgJson, { observe: 'response' }).toPromise();
    }

    // HTTP-spec-error: why is put = edit, and post = create?
    public async createOrganisation(orgJson: string): Promise<HttpResponse<any>> {
        return this.http.post(environment.API_URL + '/organisation', orgJson, { observe: 'response' }).toPromise();
    }

    public async deleteOrganisation(orgId: string): Promise<boolean> {
        return this.http.delete(environment.API_URL + '/organisation/' + orgId).toPromise()
            .then(() => true)
            .catch(() => false);
    }
}
